"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueueRoute = void 0;
exports.createQueueRoute = '/queue';
//# sourceMappingURL=createQueue.route.js.map